var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-editor',{ref:"editor",attrs:{"useCustomImageHandler":"","placeholder":_vm.placeholder,"value":_vm.value},on:{"image-added":_vm.handleImageAdded,"input":(val) => _vm.$emit('input', val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }